import { render } from "./FooterPowerSearch.vue?vue&type=template&id=949354d0&scoped=true"
import script from "./FooterPowerSearch.vue?vue&type=script&lang=js"
export * from "./FooterPowerSearch.vue?vue&type=script&lang=js"

import "./FooterPowerSearch.vue?vue&type=style&index=0&id=949354d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-949354d0"]])

export default __exports__